// Mock data for Merdekaku.id

export const heroData = {
  title: "Merdeka dengan Aksi Nyata",
  subtitle: "Platform aksi sosial anak muda untuk perubahan yang berarti",
  ctaButtons: [
  { text: "Lihat Kegiatan", type: "primary" },
  { text: "Gabung Aksi", type: "secondary" }],

  heroImage: "https://images.unsplash.com/photo-1769755411779-e4c43e7b7742?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHx5b3V0aCUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzcwMDM5NTQ2fDA&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "Tentang Merdekaku.id",
  description: "Merdekaku.id adalah platform aksi sosial yang digerakkan oleh anak muda Indonesia. Kami percaya bahwa perubahan nyata dimulai dari tindakan nyata, bukan hanya kata-kata. Melalui platform ini, kami menghubungkan anak muda yang peduli dengan aksi sosial yang berdampak langsung kepada masyarakat.",
  stats: [
  { number: "50+", label: "Relawan Aktif" },
  { number: "10+", label: "Kegiatan Sosial" },
  { number: "1000+", label: "Orang Terbantu" }]

};

export const featuredProject = {
  title: "Project Pertama: Kunjungan & Bakti Sosial ke Panti Asuhan",
  description: "Kolaborasi dengan siswa-siswi kelas XII untuk mengadakan kunjungan dan bakti sosial ke panti asuhan. Kegiatan ini meliputi penggalangan dana, pengadaan sembako dan kebutuhan sehari-hari, serta kunjungan langsung untuk berinteraksi dengan anak-anak panti.",
  image: "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjaGFyaXR5JTIwdm9sdW50ZWVyc3xlbnwwfHx8fDE3NzAwMzk1NTZ8MA&ixlib=rb-4.1.0&q=85",
  details: [
  "Penggalangan dana bersama siswa",
  "Pengadaan sembako dan perlengkapan",
  "Kunjungan dan interaksi langsung",
  "Dokumentasi kegiatan untuk transparansi"],

  date: "Februari 2026",
  location: "Panti Asuhan Coming Soon, Malang"
};

export const galleryImages = [
{
  id: 1,
  url: "https://images.unsplash.com/photo-1751666526244-40239a251eae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHx5b3V0aCUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzcwMDM5NTQ2fDA&ixlib=rb-4.1.0&q=85",
  caption: "Gotong royong mewarnai fasilitas umum"
},
{
  id: 2,
  url: "https://images.unsplash.com/photo-1758599668299-beebedfabf7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHx5b3V0aCUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzcwMDM5NTQ2fDA&ixlib=rb-4.1.0&q=85",
  caption: "Aksi bersih lingkungan"
},
{
  id: 3,
  url: "https://images.unsplash.com/photo-1593113598332-cd288d649433?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjaGFyaXR5JTIwdm9sdW50ZWVyc3xlbnwwfHx8fDE3NzAwMzk1NTZ8MA&ixlib=rb-4.1.0&q=85",
  caption: "Pengumpulan donasi"
},
{
  id: 4,
  url: "https://images.unsplash.com/photo-1593113630400-ea4288922497?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjaGFyaXR5JTIwdm9sdW50ZWVyc3xlbnwwfHx8fDE3NzAwMzk1NTZ8MA&ixlib=rb-4.1.0&q=85",
  caption: "Distribusi bantuan ke masyarakat"
},
{
  id: 5,
  url: "https://images.unsplash.com/photo-1767376133594-cf14a1f0f174?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHx5b3V0aCUyMGNvbW11bml0eSUyMHNlcnZpY2V8ZW58MHx8fHwxNzcwMDM5NTQ2fDA&ixlib=rb-4.1.0&q=85",
  caption: "Penggalangan dana lewat acara musik"
},
{
  id: 6,
  url: "https://images.unsplash.com/photo-1593113702251-272b1bc414a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjaGFyaXR5JTIwdm9sdW50ZWVyc3xlbnwwfHx8fDE3NzAwMzk1NTZ8MA&ixlib=rb-4.1.0&q=85",
  caption: "Kunjungan ke komunitas lokal"
}];


export const howItWorksSteps = [
{
  id: 1,
  title: "Ide Kegiatan Sosial",
  description: "Identifikasi masalah sosial dan susun rencana kegiatan yang berdampak",
  icon: "Lightbulb"
},
{
  id: 2,
  title: "Galang Dana Bersama",
  description: "Kumpulkan dana dan sumber daya dari komunitas yang peduli",
  icon: "Coins"
},
{
  id: 3,
  title: "Eksekusi di Lapangan",
  description: "Jalankan kegiatan sosial secara langsung dengan tim relawan",
  icon: "Users"
},
{
  id: 4,
  title: "Dokumentasi & Publikasi",
  description: "Bagikan hasil dan dampak kegiatan untuk transparansi dan inspirasi",
  icon: "Camera"
}];


export const contactFormData = {
  title: "Mari Berkolaborasi",
  description: "Punya ide kegiatan sosial atau ingin bergabung dalam aksi kami? Hubungi kami!",
  fields: [
  { name: "name", label: "Nama Lengkap", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Nomor Telepon", type: "tel", required: false },
  { name: "subject", label: "Subjek", type: "text", required: true },
  { name: "message", label: "Pesan", type: "textarea", required: true }]

};

export const footerData = {
  about: "Merdekaku.id adalah platform aksi sosial anak muda untuk menciptakan perubahan nyata di masyarakat.",
  socialMedia: [
  { platform: "Instagram", url: "https://instagram.com/merdekaku.id", icon: "Instagram" },
  { platform: "Facebook", url: "https://facebook.com/merdekaku.id", icon: "Facebook" },
  { platform: "Twitter", url: "https://twitter.com/merdekakuid", icon: "Twitter" },
  { platform: "YouTube", url: "https://youtube.com/@merdekakuid", icon: "Youtube" }],

  contact: {
    email: "merdekakuid@gmail.com",
    phone: "+62 812-3456-7890",
    address: "Malang, Indonesia"
  },
  quickLinks: [
  { label: "Tentang Kami", href: "#about" },
  { label: "Kegiatan", href: "#projects" },
  { label: "Galeri", href: "#gallery" },
  { label: "Kontak", href: "#contact" }]

};
